module.exports = __webpack_public_path__ + "img/noshoppingdata.b430b555.png";